// @ts-ignore
 
import request from "src/lib/axios";

/** 读取 HQ 系统配置列表 GET /api/v1/hq/setting */
export async function HqSettingControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqSettingControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputConfigDtoArray>("/api/v1/hq/setting", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 保存单个 HQ 系统配置 PUT /api/v1/hq/setting */
export async function HqSettingControllerUpsertV1(
  body: MyApi.UpsertConfigDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputConfigDto>("/api/v1/hq/setting", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 读取单个 HQ 系统配置 GET /api/v1/hq/setting/${param0} */
export async function HqSettingControllerGetByKeyV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqSettingControllerGetByKeyV1Params,
  options?: { [key: string]: any }
) {
  const { key: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputConfigDto>(
    `/api/v1/hq/setting/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 删除 HQ 系统配置项 DELETE /api/v1/hq/setting/${param0} */
export async function HqSettingControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqSettingControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { key: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(`/api/v1/hq/setting/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 批量保存 HQ 系统配置 PUT /api/v1/hq/setting/batch */
export async function HqSettingControllerBatchUpsertV1(
  body: MyApi.BatchUpsertConfigDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputConfigDtoArray>(
    "/api/v1/hq/setting/batch",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
